module.exports = __webpack_public_path__ + "img/1sb_customer_review_icon.e6a432a.svg";